import * as React from 'react';
import Chip from '@mui/material/Chip';
import Box from '@mui/material/Box';

export default function DeletableChips({ selectedCauses, deleteSelectedCause }) {
  const handleDelete = () => {
    console.info('You clicked the delete icon.');
  };

  return (
    <>
      <Box sx={{ display: 'flex', flexWrap: 'wrap' }}>
        {selectedCauses.map((cause) => (
          <Chip key={cause} label={cause} onDelete={() => deleteSelectedCause(cause)} sx={{ mr: 1, mt:1 }} />
        ))}
      </Box>
    </>
  );
}
